import { Form, Formik } from "formik";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { MedicalVisit } from "../types/FormTypes";
import { medicalVisitAtom } from "./AddCertificate";
import { useRef } from "react";
import { useIsAddMoreTrue } from "./AddMore";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { URLS } from "src/config/urls";

import {
  Box,
  handleSubmitClick,
  ErrorList,
  Button,
  Progressbar,
  MultipleFileUploadField,
  FormTextarea,
  Link,
  Heading,
} from "@ogt/ui";

export default function OtherUploads() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(medicalVisitAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const [isAddMoreTrue] = useIsAddMoreTrue();
  const progress = isAddMoreTrue ? 87 : 75;

  return (
    <div>
      <Formik<MedicalVisit>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });
          navigate("../fler-resor");
        }}
        initialValues={{
          ...formData,
        }}
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize
      >
        {({ errors, touched, values }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-40 w-full max-w-xs mb-4">
                {isAddMoreTrue ? (
                  <Progressbar percentage={progress} />
                ) : (
                  <Progressbar percentage={progress} />
                )}
              </div>
            </div>
            <Form ref={formRef}>
              <Box>
                <>
                  <Heading progress={progress} headingRef={h2Ref} focusable>
                    Övriga kostnader
                  </Heading>

                  <ErrorList errors={errors} />

                  <p className="mb-10">
                    I vissa fall kan kostnader för exempelvis övernattning
                    ersättas. Läs mer om vad du kan få ersättning för på{" "}
                    <Link
                      target="_blank"
                      rightIcon="external-link"
                      href={URLS.healthInformation}
                    >
                      1177.se
                    </Link>
                  </p>

                  <div className="mb-10">
                    <MultipleFileUploadField
                      currentFiles={values.otherFiles}
                      multiple={true}
                      label="Bifoga kvitto för övriga kostnader (frivilligt)"
                      inputId="otherFiles"
                      inputName="otherFiles"
                    />
                  </div>

                  <div>
                    <FormTextarea
                      fielddescription
                      name="comments"
                      maxLength={5000}
                      currentText={values.comments}
                      label={"Övriga kommentarer (frivilligt)"}
                    />
                  </div>
                </>
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button
                    onClick={handleSubmitClick(formRef)}
                    className="btn secondary"
                    type="submit"
                  >
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
